/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { func } from 'prop-types';
import Button from '@material-ui/core/Button';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { actions as tagManagerActions } from '../../../../../../state/ducks/TagManager';
import memberDucks from '../../../../../../state/ducks/Member/ducks';
import { useAuth } from '../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const {
    common: {
        commonSelectors,
    },
} = memberDucks;

const DesktopSignInOrder = ({
    trackEvent,
}) => {
    const { loginByRedirect } = useAuth();

    const ffGcsStaticPath = useSelector(getFeatureFlag('gcs-static-asset-path'));
    const staticPrefix = ffGcsStaticPath || '';

    const handleSignInClicked = async (method) => {
        let isSignedIn = false;

        if (method === 'signin') {
            isSignedIn = await loginByRedirect();
        } else if (method === 'facebook') {
            isSignedIn = await loginByRedirect({ connection: 'facebook' });
        } else if (method === 'google') {
            isSignedIn = await loginByRedirect({ connection: 'google-oauth2' });
        }

        if (isSignedIn && typeof window !== 'undefined') {
            window.location.reload();
        }
    };

    return (
        <>
            <div className="signInContainer">
                <h2 className="subHeader">Sign in to get order details</h2>
                <div className="signInBtnWrapper">
                    <Button
                        className="signInBtn"
                        onClick={async () => {
                            handleSignInClicked('signin');
                            trackEvent({
                                eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Normal|<<pageType>>',
                            });
                        }}
                    >
                        Sign In
                    </Button>
                    <Button
                        className="signInWithoutPasswordBtn"
                        style={{ display: 'none' }} // to be removed when working properly
                        onClick={async () => {
                            await loginByRedirect({}, { routeBack: '/', magicLogin: 'Y' });

                            trackEvent({
                                eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Sign-In_Redirect|<<pageType>>',
                            });
                        }}
                    >
                        Sign In Without Password
                    </Button>
                </div>
                <div className="signUpDivider">
                    <hr />
                    <span>Or sign in with</span>
                    <hr />
                </div>
                <div className="socialBtn">
                    <Button
                        className="loginSocialBtn facebookLogin"
                        onClick={async () => {
                            handleSignInClicked('facebook');
                            trackEvent({
                                eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Facebook|<<pageType>>',
                            });
                        }}
                    >
                        <img className="socialLoginImg" src={`${staticPrefix}/static/images/fb_white.svg`} alt="Facebook" />
                        <span className="small">Sign in with Facebook</span>
                    </Button>
                    <Button
                        className="loginSocialBtn googleLogin"
                        onClick={async () => {
                            handleSignInClicked('google');
                            trackEvent({
                                eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Logon_From_Google|<<pageType>>',
                            });
                        }}
                    >
                        <img className="socialLoginImg" src={`${staticPrefix}/static/images/google.svg`} alt="Google" />
                        <span className="small">Sign in with Google</span>
                    </Button>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    isAuthenticated: commonSelectors.getIsAuthenticatedStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
});

DesktopSignInOrder.propTypes = {
    trackEvent: func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopSignInOrder);
